import {Injectable}                                                                                                                                               from '@angular/core';
import {CrudPathDict, HkitHeartAlertsIntf, HkitRecordGroupSubDict, HkitRecordLogIntf, HkitRecordLogType, HkitRecordSumType, HkitRecordUnionType, HkitWorkoutIntf} from '@djsharkk/logr-types';
import {BehaviorSubject, map, Observable, Subscription}                                                                                                           from 'rxjs';
import {DataFirebaseBase}                                                                                                                                         from './data-firebase.base';


export type HkitLogSubDict = HkitRecordGroupSubDict<HkitRecordLogType, BehaviorSubject<HkitRecordLogIntf[]>>
export type HkitSumSubDict = HkitRecordGroupSubDict<HkitRecordSumType, BehaviorSubject<HkitRecordLogIntf[]>>

@Injectable({
				providedIn: 'root'
			})
export class DataHkitService extends DataFirebaseBase<HkitRecordLogIntf, HkitRecordLogIntf> {

	protected paths: CrudPathDict = {
		log: 'hkit_records_log',
		sum: 'hkit_records_sum'
	};

	recordsHeartAlerts: BehaviorSubject<HkitHeartAlertsIntf[]> = new BehaviorSubject<HkitHeartAlertsIntf[]>([]);
	recordsWorkouts: BehaviorSubject<HkitWorkoutIntf[]> = new BehaviorSubject<HkitWorkoutIntf[]>([]);

	subHeartAlerts?: Subscription;
	subWorkouts?: Subscription;
	// subRecords: Subscription;

	/*typesByGroup: HkitRecordGroupDict<HkitRecordLogType[], HkitRecordSumType[]> = {
	 log: HkitRecordLogTypes,
	 sum: HkitRecordSumTypes
	 }*/

	/*	recordsByType: HkitRecordGroupDict<
	 HkitLogSubDict,
	 HkitSumSubDict
	 > = {
	 log: {
	 blood_oxygen_saturation     : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 environmental_audio_exposure: new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 handwashing                 : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 headphone_audio_exposure    : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 respiratory_rate            : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 toothbrushing               : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 weight_body_mass            : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 dietary_water               : new BehaviorSubject<HkitRecordLogIntf[]>([])
	 },
	 sum: {
	 dietary_water      : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 active_energy      : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 apple_exercise_time: new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 apple_stand_time   : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 step_count         : new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 basal_energy_burned: new BehaviorSubject<HkitRecordLogIntf[]>([]),
	 time_in_daylight   : new BehaviorSubject<HkitRecordLogIntf[]>([])
	 }

	 };*/

	constructor() {
		super();
		this.subHeartAlerts = this.svcFirebaseTools.recFetch<HkitHeartAlertsIntf>('hkit_records_log_heart_alerts', 'start').subscribe((records) => this.recordsHeartAlerts.next(records));
		this.subWorkouts = this.svcFirebaseTools.recFetch<HkitWorkoutIntf>('hkit_records_log_workouts', 'start').subscribe((records) => this.recordsWorkouts.next(records));
		/*this.subRecords = this.records.log.subscribe(records => {
		 GlobalRecordGroupTypes.forEach(group => {
		 this.typesByGroup[group].forEach(type => {
		 const g = (this.recordsByType[group] as typeof group extends 'log' ? HkitLogSubDict : HkitSumSubDict);
		 const t = type as typeof group extends 'log' ? HkitRecordLogType : HkitRecordSumType;
		 g[t].next(this.getRecordsByType(records, type));
		 })
		 })
		 })*/
	}


	filterBehaviorSubject(type: HkitRecordUnionType): Observable<HkitRecordLogIntf[]> {
		return this.getRecordsLog() // Convert the BehaviorSubject into an Observable
				   .pipe(
					   map(items => items.filter(item => item.type === type)) // Apply the filter logic
				   );
	}

	getRecordsByType(records: HkitRecordLogIntf[], type: HkitRecordUnionType): HkitRecordLogIntf[] {
		return records.filter(record => record.type === type)
	}

}